/* "Vaak samen gekocht" on the cart page (snippets/sr-cart-pair.liquid): adds the
   pillowcase and re-renders the cart sections the way Dawn's cart-items does,
   without reloading the page. */
(() => {
  if (window.srCartPairBound) return;
  window.srCartPairBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sr-cart-pair]');
    if (!button) return;
    const cartItems = document.querySelector('cart-items');
    const sections = cartItems && cartItems.getSectionsToRender ? cartItems.getSectionsToRender() : [];

    button.disabled = true;
    button.classList.add('loading');
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.srCartPair), quantity: 1 }],
          sections: sections.map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status || !state.sections) {
        window.location.reload();
        return;
      }
      sections.forEach((section) => {
        const host = document.getElementById(section.id);
        const html = state.sections[section.section];
        if (!host || !html) return;
        const target = host.querySelector(section.selector) || host;
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (source) target.innerHTML = source.innerHTML;
      });
    } catch (error) {
      window.location.reload();
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
    }
  });
})();
